import { render, staticRenderFns } from "./_bottomSlot.vue?vue&type=template&id=ac35593e&"
import script from "./_bottomSlot.vue?vue&type=script&lang=ts&"
export * from "./_bottomSlot.vue?vue&type=script&lang=ts&"
import style0 from "./_bottomSlot.vue?vue&type=style&index=0&id=ac35593e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports